(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqToggle extends HTMLElement {
    constructor() {
      super();

      this.headings = this.querySelectorAll('.faq-group-headings .faq-group-heading');
      this.contentGroups = this.querySelectorAll('.faq-group-contents .faq-group-content');

      this.mobileHeadings = this.querySelectorAll('.faq-group .faq-group-heading');
      this.mobileGroup = this.querySelectorAll('.faq-group');

      for (const heading of this.headings) {
        heading.addEventListener('click', (e) => {
          e.preventDefault();

          this.setActiveHeading(e.target);
          this.setActiveGroupContents(e.target.dataset.group);
        })
      }

      for (const heading of this.mobileHeadings) {
        heading.addEventListener('click', (e) => {
          e.preventDefault();

          this.setActiveMobileGroup(e.target.dataset.group);
        })
      }
    }

    setActiveHeading(target) {
      for ( let heading of this.headings ) {
        heading.classList.remove('active');
      }

      target.classList.add('active');
    }

    setActiveGroupContents(slug) {
      for ( let contentGroup of this.contentGroups ) {
        contentGroup.classList.remove('active');
      }

      this.querySelector(`.faq-group-contents .faq-group-content[data-group="${slug}"]`).classList.add('active');
    }

    setActiveMobileGroup(slug) {
      for ( let group of this.mobileGroup ) {
        group.classList.remove('active');
      }

      for ( let heading of this.mobileHeadings ) {
        console.log(heading.querySelector('span'))
        heading.querySelector('span').innerHTML = "&plus;";
      }

      this.querySelector(`.faq-group[data-group="${slug}"]`).classList.add('active');
      this.querySelector(`.faq-group[data-group="${slug}"] .faq-group-heading`).querySelector('span').innerHTML = "&dash;";
    }
  }

  customElements.define("faq-toggle", FaqToggle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class MenuDropdown extends HTMLElement {
    constructor() {
      super();
      this.toggler = this.querySelector('.header-menu__dropdown-toggler');
      this.dropdown = this.querySelector('.header-menu__dropdown');
      
      if (this.toggler && this.dropdown) {
        // Use native hover events as fallback
        this.toggler.addEventListener('mouseenter', () => {
          this.dropdown.classList.add('active');
        });
        
        this.addEventListener('mouseleave', () => {
          this.dropdown.classList.remove('active');
        });
      }
    }
  }
  customElements.define('menu-dropdown', MenuDropdown);

  class HeaderSearch extends HTMLElement {
    constructor() {
      super();

      this.visible = false;
      this.toggler = document.querySelector('.header-actions__search-button');
      this.closeButton = this.querySelector('.header-search__close');

      this.closeButton.addEventListener('click', this.close.bind(this));
      this.toggler.addEventListener('click', this.toggleVisibility.bind(this));
      document.addEventListener('click', this.maybeClose.bind(this));
    }

    open() {
      this.classList.add('visible')
      this.visible = true;
      setTimeout(() => {
        this.querySelector('input.search-input').focus();
      }, 100)

    }

    close(event) {
      if (event) event.preventDefault();
      this.classList.remove('visible');
      this.visible = false;
      this.querySelector('.predictive-search-results').innerHTML = '';
    }

    toggleVisibility(event) {
      event.preventDefault();
      if (this.visible) {
        this.close();
      } else {
        this.open();
      }
    }

    maybeClose(e) {
      if (!this.contains(e.target) && !this.toggler.contains(e.target) ) {
        this.close();
      };
    }
  }
  customElements.define('header-search', HeaderSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-straps"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
          element.closest('.product-media-modal__content-wrap').classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.closest('.product-media-modal__content-wrap').classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  class ProductMeta extends HTMLElement {
    constructor() {
      super();

      this.toggle = this.querySelector('.product-meta__toggle');
      this.main = this.querySelector('.product-meta__main');
      this.table = this.querySelector('.product-meta__table');
      this.open = true;

      if (this.toggle) this.toggle.addEventListener('click', this.handleToggle.bind(this));
    }

    handleToggle(e) {
      this.open ? this.handleClose() : this.handleOpen();
    }

    handleOpen() {
      this.main.classList.remove('open');
      this.table.classList.add('open');
      this.open = true;
      this.toggle.innerHTML = '&ndash; Show less'
    }

    handleClose() {
      this.main.classList.add('open');
      this.table.classList.remove('open');
      this.open = false;
      this.toggle.innerHTML = '&plus; View all'
    }
  };
  customElements.define('product-meta', ProductMeta);

  } catch(e) { console.error(e); }
})();
})();
